import * as i0 from '@angular/core';
import { Injectable, InjectionToken, Inject, Optional, APP_INITIALIZER, NgModule } from '@angular/core';
import { __rest, __awaiter } from 'tslib';
import * as i1 from '@angular/common/http';
import { HttpHeaders, HttpParams, HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { throwError, of, forkJoin, interval, Subject, EMPTY } from 'rxjs';
import { map, catchError, mergeMap, switchMap } from 'rxjs/operators';
import * as i1$1 from '@angular/router';
import { NavigationEnd, Router } from '@angular/router';
import { coerceArray } from '@angular/cdk/coercion';

/**
 * Enum of App login urls
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common/http';
import * as ɵngcc2 from '@angular/router';
var AppLoginUrl;
(function (AppLoginUrl) {
    AppLoginUrl["PUBLISHER"] = "/login/publisher";
    AppLoginUrl["PUBLISHER_ADMIN"] = "/login/admin";
    AppLoginUrl["DEMAND"] = "/login/demand";
    AppLoginUrl["DEMAND_ADMIN"] = "/login/admin/demand";
    AppLoginUrl["COMMUNITY"] = "/login/community";
})(AppLoginUrl || (AppLoginUrl = {}));

/**
 * ACL-Controller class
 * This class handles the api-communication for fetching the features related to User
 * as well as Publisher.
 * param authKey Authorization key i.e. the name of the header to send for authorization
 * param authVal Authorization value
 */
class AclService {
    constructor(http) {
        this.http = http;
        this._apiBase = '';
        this.endPoints = {
            userInfo: "/api/castrum/users" /* userInfo */,
            userFeatures: "/api/castrum/userFeatures" /* userFeatures */,
            resourceFeatures: "/api/castrum/aclResourceFeatures" /* resourceFeatures */
        };
    }
    get token() {
        return this._token;
    }
    set token(conf) {
        this._token = conf;
    }
    get apiBase() {
        return this._apiBase;
    }
    set apiBase(value) {
        this._apiBase = value;
    }
    buildHeaders(extraHeaders) {
        const headers = (extraHeaders || new HttpHeaders())
            .set(this.token.key, this.token.value);
        return headers;
    }
    fetch(endpoint, params, extraHeaders) {
        const headers = this.buildHeaders(extraHeaders);
        return this.http.get(this.apiBase + endpoint, { headers, params });
    }
    /**
    * This is for backward compatibility.
    * TODO: Remove post method in next major release
    * @deprecated This method is deprecated
    * */
    post(endpoint, body) {
        const headers = this.buildHeaders();
        return this.http.post(this.apiBase + endpoint, body, { headers });
    }
    get(endpoint) {
        const headers = this.buildHeaders();
        return this.http.get(this.apiBase + endpoint, { headers });
    }
    /**
     * options.resourceId
     * options.resourceTypeId
     * options.pageNumber [1]
     * options.pageSize [10000]
     */
    fetchResFeatures(options) {
        if (!options.resourceId || !options.resourceTypeId) {
            return throwError('resourceType and resourceTypeId are required to fetch resource features.');
        }
        const params = new HttpParams()
            .set('pageNumber', `${options.pageNumber || 1}`)
            .set('pageSize', `${options.pageSize || 10000}`)
            .set('resourceId', `${options.resourceId}`)
            .set('resourceTypeId', `${options.resourceTypeId}`);
        return this.fetch(this.endPoints.resourceFeatures, params);
    }
    /**
     * options.pageNumber [1]
     * options.pageSize [10000]
     */
    fetchUserFeatures(options = {}) {
        const params = new HttpParams()
            .set('pageNumber', `${options.pageNumber || 1}`)
            .set('pageSize', `${options.pageSize || 10000}`);
        return this.fetch(this.endPoints.userFeatures, params);
    }
    fetchUserInfo() {
        return this.get(this.endPoints.userInfo)
            .pipe(map(data => {
            const _a = Object.assign({}, data), { userInfo = null, disabled = null, modificationTime = null, creationTime = null } = _a, rest = __rest(_a, ["userInfo", "disabled", "modificationTime", "creationTime"]);
            return Object.assign(Object.assign({}, rest), { username: rest.email });
        }));
    }
}
AclService.ɵfac = function AclService_Factory(t) { return new (t || AclService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient)); };
AclService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: AclService, factory: AclService.ɵfac });
AclService.ctorParameters = () => [
    { type: HttpClient }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AclService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.HttpClient }]; }, null); })();

class SessionConfig {
    constructor(props = {}) {
        this.serverPath = '/session-server/';
        this.sessionServer = window.location.origin + this.serverPath;
        this.setProperties(props);
    }
    get token() {
        return {
            key: this.authKey,
            value: this.authVal
        };
    }
    setProperties(props) {
        Object.assign(this, props);
    }
    hasToken() {
        return !!(this.authKey && this.authVal);
    }
}

class SessionData {
    constructor() {
        this.config = new SessionConfig();
    }
    static removeItem(key) {
        sessionStorage.removeItem(`${this.KEY_PREFIX}.${key}`);
    }
    static fetchItem(key) {
        return sessionStorage.getItem(`${this.KEY_PREFIX}.${key}`);
    }
    static saveItem(key, value) {
        sessionStorage.setItem(`${this.KEY_PREFIX}.${key}`, String(value));
    }
    static fetchJsonItem(key) {
        const val = this.fetchItem(key);
        return JSON.parse(val);
    }
    static saveJsonItem(key, value) {
        this.saveItem(key, JSON.stringify(value));
    }
    static clearStore() {
        this.removeItem('authKey');
        this.removeItem('authVal');
        this.removeItem('accountType');
        this.removeItem('attrs');
        this.removeItem('userInfo');
        this.removeItem('userFeatures');
        this.removeItem('accountFeatures');
        this.removeItem('accountDetails');
    }
    save() {
        SessionData.saveItem('authKey', this.config.authKey);
        SessionData.saveItem('authVal', this.config.authVal);
        SessionData.saveItem('sso', this.config.sso);
        SessionData.saveItem('accountType', this.config.accType);
        SessionData.saveJsonItem('attrs', this.attrs);
        SessionData.saveJsonItem('userInfo', this.userInfo);
        SessionData.saveJsonItem('userFeatures', this.userFeatures);
        SessionData.saveJsonItem('accountFeatures', this.accountFeatures);
        SessionData.saveJsonItem('accountDetails', this.accountDetails);
    }
    fetch() {
        this.attrs = SessionData.fetchJsonItem('attrs') || {};
        this.userInfo = SessionData.fetchJsonItem('userInfo');
        this.userFeatures = SessionData.fetchJsonItem('userFeatures') || {};
        this.accountFeatures = SessionData.fetchJsonItem('accountFeatures') || {};
        this.accountDetails = SessionData.fetchJsonItem('accountDetails') || {};
        this.config.setProperties({
            authKey: SessionData.fetchItem('authKey'),
            authVal: SessionData.fetchItem('authVal'),
            sso: SessionData.fetchItem('sso') === 'true',
            accType: SessionData.fetchItem('accountType'),
            accId: this.accountDetails.id || ''
        });
    }
}
SessionData.KEY_PREFIX = 'sm';

/**
 * Used to inject `window` into components.
 * Similar to built-in `DOCUMENT` injection token
 */
const WINDOW = new InjectionToken('window', {
    providedIn: 'root',
    factory: () => window
});

const PRODUCTION_ENVIRONMENT = 'apps';
class CommonUtilsService {
    // TODO: Use this injected window object everywhere before next major version release
    constructor(window) {
        this.window = window;
    }
    getWindowLocation() {
        return window.location.href;
    }
    /**
     * Redirect to given url
     * @param url To redirect to given location
     * @returns Url which is being redirected
     */
    redirectTo(url) {
        return window.location.href = url;
    }
    /**
     * Convert to absolute URL if not already
     * @param urlPath Relative/Absolute URL
     * @returns Absolute URL for the input URL
     */
    qualifyURL(urlPath) {
        const a = document.createElement('a');
        a.href = urlPath;
        return a.href;
    }
    getOriginFromURL(urlPath) {
        const a = document.createElement('a');
        a.href = urlPath;
        return a.origin;
    }
    /**
     * This function returns the Current Environment
     * i.e. domain name of current environment
     */
    getEnvironmentName() {
        // ci-sv3-mgmt.pubmatic.com => ci-sv3-mgmt
        let environment = this.window.location.host.replace(/.pubmatic.com/g, '');
        // localhost:4200 => localhost
        environment = environment.split(':')[0];
        return environment;
    }
    /**
     * To check if current environment is Production environment or not
     */
    isProdEnvironment() {
        const environment = this.getEnvironmentName();
        return environment === PRODUCTION_ENVIRONMENT;
    }
}
CommonUtilsService.ɵfac = function CommonUtilsService_Factory(t) { return new (t || CommonUtilsService)(ɵngcc0.ɵɵinject(WINDOW)); };
CommonUtilsService.ɵprov = i0.ɵɵdefineInjectable({ factory: function CommonUtilsService_Factory() { return new CommonUtilsService(i0.ɵɵinject(WINDOW)); }, token: CommonUtilsService, providedIn: "root" });
CommonUtilsService.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [WINDOW,] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CommonUtilsService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [WINDOW]
            }] }]; }, null); })();

class SessionManagerService {
    constructor(acl, commonUtils) {
        this.acl = acl;
        this.commonUtils = commonUtils;
        this.userAccessMap = {};
        this.accountAccessMap = {};
        this.config = new SessionConfig();
        this._attrs = {};
        this._accountDetails = {};
        this.isInit = false;
        this.restoreSession();
    }
    /**
     * Initialize Session Manager, it can create new session or restore previous
     * @param config Configuration for SM
     * @param [config.authKey] API access key
     * @param [config.authVal] API access token value
     * @param [config.sso] Single Sign-On
     * @param [config.accId] account-id of the publisher/demand partner/atd
     * @param [config.accType] type of the account, basically resource-type
     * @param [config.apiBase] Optional location where API is hosted
     * @returns Observable
     */
    init(config) {
        let result$ = null;
        if (this.isInitialized()) {
            console.warn('Re-initializing session');
        }
        this.config.setProperties(config);
        if (this.config.hasToken()) {
            result$ = this.createSession();
        }
        else {
            result$ = throwError('API Token is required to create the session');
        }
        return result$;
    }
    /**
     * Create session by fetching data from castrum APIs. This is Async method.
     * @returns Observable
     */
    createSession() {
        this.acl.token = this.config.token;
        this.acl.apiBase = this.config.apiBase;
        this._accountDetails = this.config.accId ? { id: String(this.config.accId) } : {};
        const userAccessMap$ = this.loadUserFeatures();
        let accountAccessMap$ = of(this.accountAccessMap);
        // Ref : https://inside.pubmatic.com:8443/confluence/x/kJxRBg
        if (this.config.accId && !(this.config.accType === 1 /* PUBLISHER */ && this.config.accId === 1)) {
            accountAccessMap$ = this.loadAccountFeatures(this.config);
        }
        const userInfo$ = this.acl.fetchUserInfo();
        return forkJoin([userAccessMap$, accountAccessMap$, userInfo$])
            .pipe(map(([userAccessMap, accountAccessMap, userInfo]) => {
            this.userAccessMap = userAccessMap;
            this.accountAccessMap = accountAccessMap;
            this.userInfo = userInfo;
            this.storeSession();
            this.isInit = true;
            return { userAccessMap, accountAccessMap, userInfo };
        }));
    }
    /**
     * Restore the session from current domain
     */
    restoreSession() {
        const data = new SessionData();
        data.fetch();
        this.setSessionData(data);
        this.isInit = this.config.hasToken();
    }
    isInitialized() {
        return this.isInit;
    }
    buildAccess(type, features) {
        const accessMap = {};
        switch (type) {
            case 'USER':
                features.forEach(function (f) {
                    accessMap[f.id] = {
                        name: f.featureName,
                        access: f.permissionId
                        /*
                          desc: f.description,
                          group: f.featureGroup,
                        */
                    };
                });
                break;
            case 'ACCOUNT':
                features.forEach(function (f) {
                    accessMap[f.featureId] = {
                        name: f.featureName,
                        access: true
                    };
                });
                break;
        }
        return accessMap;
    }
    storeSession() {
        const data = new SessionData();
        data.config = this.config;
        data.userFeatures = this.userAccessMap;
        data.accountFeatures = this.accountAccessMap;
        data.userInfo = this.userInfo;
        data.attrs = this._attrs;
        data.accountDetails = this._accountDetails;
        data.save();
    }
    setSessionData(sessionData) {
        this.config.setProperties(sessionData.config);
        this.userAccessMap = sessionData.userFeatures;
        this.accountAccessMap = sessionData.accountFeatures;
        this.userInfo = sessionData.userInfo;
        this._attrs = sessionData.attrs;
        this._accountDetails = sessionData.accountDetails;
        this.acl.token = this.config.token;
        this.acl.apiBase = this.config.apiBase;
    }
    /**
     * Load user features from castrum 1 and castrum 2 APIs
     */
    loadUserFeatures() {
        return this.acl.fetchUserFeatures().pipe(map(userFeatures => this.buildAccess('USER', userFeatures.items)));
    }
    /**
     * Load features for specified account
     */
    loadAccountFeatures(config) {
        return this.acl.fetchResFeatures({
            resourceId: Number(config.accId),
            resourceTypeId: Number(config.accType)
        }).pipe(map(resFeatures => this.buildAccess('ACCOUNT', resFeatures.items)));
    }
    /**
    * Remove keys from sessionStorage that were set by Session Manager
    */
    clearSession() {
        SessionData.clearStore();
    }
    /**
     * Get user-level access for castrum features
     */
    getAccess(featureId) {
        return this.userAccessMap[featureId] ? this.userAccessMap[featureId].access : 0 /* NONE */;
    }
    /**
     * Get Account Level Access for Castrum features
     */
    getAccountAccess(featureId) {
        return this.accountAccessMap[featureId] ? this.accountAccessMap[featureId].access : 0 /* NONE */;
    }
    /**
     * Get API token
     */
    getApiToken() {
        return Object.assign({}, this.config.token);
    }
    /**
     * Get the accountId
     */
    getAccountId() {
        return String(this.config.accId);
    }
    /**
     * Get the account type
     */
    getAccountType() {
        return String(this.config.accType);
    }
    /**
     * Get user information {id, firstName, lastName, email, username}
     */
    getUser() {
        return this.userInfo;
    }
    /**
     * Set details for the currently set account
     */
    setAccountDetails(details) {
        details.id = this.config.accId || details.id;
        this._accountDetails = details;
        SessionData.saveJsonItem('accountDetails', details);
    }
    /**
     * Get details for the current account
     */
    getAccountDetails() {
        return this._accountDetails;
    }
    /**
     * Get custom stored data
     */
    get(key) {
        return !key ? this._attrs : this._attrs[key];
    }
    set(key, val) {
        const isMap = typeof key === 'object';
        if (isMap) {
            this._attrs = Object.assign(this._attrs, key);
        }
        else {
            this._attrs[key] = val;
        }
        SessionData.saveJsonItem('attrs', this._attrs);
    }
    getAppName() {
        const app = this.get('currentApp');
        let name;
        switch (app) {
            case "demand" /* DEMAND */:
                name = "DEMAND" /* DEMAND */;
                break;
            case "demand_admin" /* DEMAND_ADMIN */:
                name = "DEMAND_ADMIN" /* DEMAND_ADMIN */;
                break;
            case "publisher" /* PUBLISHER */:
                name = "PUBLISHER" /* PUBLISHER */;
                break;
            case "admin" /* PUBLISHER_ADMIN */:
                name = "PUBLISHER_ADMIN" /* PUBLISHER_ADMIN */;
                break;
        }
        return name;
    }
    redirectToLogin(appName, redirectBack = true) {
        const url = redirectBack
            ? `${AppLoginUrl[appName]}?ref=${encodeURIComponent(location.href)}`
            : AppLoginUrl[appName];
        this.commonUtils.redirectTo(url);
    }
    /**
     * Clear cookies and sessionStorage for logout
     */
    clearCookiesAndSession() {
        const exclude = [
            "username" /* USERNAME */,
            "gdprConsent" /* GDPR_CONSENT */
        ];
        sessionStorage.clear();
        const clearLSKeys = ['okta-token-storage', 'okta-cache-storage'];
        clearLSKeys.forEach(key => localStorage.removeItem(key));
        Object.keys(this.getAllCookies()).forEach((key) => {
            if (exclude.find((cookieName) => cookieName === key)) {
                return;
            }
            this.deleteCookie(key);
            this.deleteCookie(key, '/');
        });
    }
    /**
     * Get all cookies added for current domain
     * @returns Cookie key value object
     */
    getAllCookies() {
        const cookie = {}, decodedCookie = decodeURIComponent(document.cookie);
        decodedCookie.split(';').forEach(el => {
            const [k, v] = el.split('=');
            cookie[k.trim()] = v;
        });
        return cookie;
    }
    /**
     /**
     * Get Cookie details by name
     * @param name Cookie name to retrieve the details
     * @returns Cookie value
     */
    getCookie(name) {
        return this.getAllCookies()[name];
    }
    /**
     * Delete cookie by name
     * @param name Cookie name to delete
     * @param path Location where cookie set, defaults to blank
     */
    deleteCookie(name, path = '') {
        if (this.getCookie(name)) {
            document.cookie = name + '=' + (path ? ';path=' + path : '') + ';expires=Thu, 01-Jan-1970 00:00:01 GMT';
        }
    }
    getAdminSession() {
        const OPSTRING_INDEX = 0;
        const GROUPS_VALUE_INDEX = 7;
        const adminCookie = this.getCookie('admininfo') || '';
        const adminSessionValues = adminCookie.split(',');
        return {
            groups: adminSessionValues[GROUPS_VALUE_INDEX] ? adminSessionValues[GROUPS_VALUE_INDEX].split(':') : [],
            opString: adminSessionValues[OPSTRING_INDEX] || ''
        };
    }
    /**
    * provides list of adminGroups
    */
    getAdminGroups() {
        return this.getAdminSession().groups;
    }
    hasGroupAccess(groupId) {
        // const userGroups = sm.get('userGroups') || []; TODO
        const userGroups = this.getAdminGroups();
        return (groupId !== undefined) && userGroups.includes(groupId.toString());
    }
    hasGroup(groupId) {
        const userGroups = this.get('userGroups') || [];
        return (groupId !== undefined) && userGroups.some((group) => group.id === groupId);
    }
    getAdminUserFeatures() {
        const userSettingsCookie = this.getCookie('userSettings') || '';
        let featureList = [];
        if (userSettingsCookie) {
            featureList = userSettingsCookie.split('-');
        }
        return featureList;
    }
    hasAdminUserFeatureAccess(featureId) {
        if (!featureId) {
            return false;
        }
        const features = this.getAdminUserFeatures();
        return features.includes(featureId.toString());
    }
    /**
    * This is required for all servlet calls
    */
    getOpString() {
        const authToken = this.get('authToken');
        const adminSession = this.getAdminSession();
        return authToken || adminSession.opString;
    }
    isSSOEnabled() {
        return this.config.sso;
    }
}
SessionManagerService.ɵfac = function SessionManagerService_Factory(t) { return new (t || SessionManagerService)(ɵngcc0.ɵɵinject(AclService), ɵngcc0.ɵɵinject(CommonUtilsService)); };
SessionManagerService.ɵprov = i0.ɵɵdefineInjectable({ factory: function SessionManagerService_Factory() { return new SessionManagerService(i0.ɵɵinject(AclService), i0.ɵɵinject(CommonUtilsService)); }, token: SessionManagerService, providedIn: "root" });
SessionManagerService.ctorParameters = () => [
    { type: AclService },
    { type: CommonUtilsService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SessionManagerService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: AclService }, { type: CommonUtilsService }]; }, null); })();

class ApiBase {
    getDefaultHeaders() {
        return new HttpHeaders().set('Content-Type', 'application/json;charset=UTF-8');
    }
    /**
     * This is a generic error handler. It will be used to log all the api failure in logging framework.
     */
    handleError(operation, result) {
        return (error) => {
            // TODO: use logging framework for log these error.
            console.error(error); // log to console instead
            // TODO: raise a event for consumption of applications.
            console.error(`${operation} failed: ${error.message}`);
            throw error;
        };
    }
}

const AUTH_STRATEGY = new InjectionToken('AuthStrategy');
const pubtokenStrategyProvider = {
    provide: AUTH_STRATEGY,
    useValue: 'PubToken',
};
class RestService extends ApiBase {
    constructor(http, sm, authStrategy) {
        super();
        this.http = http;
        this.sm = sm;
        this.authStrategy = authStrategy;
    }
    /**
     * prepares bodyParams as FormData()
     * works with number/string/Array(number,string)/json object
     */
    static createFormData(bodyParams) {
        const isObject = (item) => {
            return (typeof item === 'object' && !Array.isArray(item) && item !== null);
        };
        return Object.keys(bodyParams).reduce((formData, key) => {
            const value = bodyParams[key];
            if (value !== undefined) {
                if (Array.isArray(value)) {
                    value.forEach(val => {
                        formData.append(`${key}`, val);
                    });
                }
                else if (isObject(value)) {
                    formData.append(key, JSON.stringify(value));
                }
                else {
                    formData.append(key, String(value));
                }
            }
            return formData;
        }, new FormData());
    }
    /**
    * This a private function used to merge default headers and custom application headers.
    */
    buildHeaders(extraHeaders, addDefaultHeaders) {
        let headers = addDefaultHeaders ? this.getDefaultHeaders() : new HttpHeaders();
        if (this.sm.isInitialized() && (this.authStrategy === 'PubToken' || !this.authStrategy)) {
            const token = this.sm.getApiToken();
            headers = headers.set(token.key, token.value);
        }
        if (extraHeaders) {
            /**
             * set() is used over append() so as to provide ability to completely override header value
             * from consumer's side
             */
            extraHeaders.keys().forEach(key => {
                headers = headers.set(key, extraHeaders.get(key));
            });
        }
        return headers;
    }
    /**
    * This a private function used to merge default httpOptions with custom http options set by application.
    */
    buildHttpOptions(options, addDefaultHeaders = true) {
        const opts = options || { headers: new HttpHeaders() };
        const resultOptions = Object.assign(Object.assign({}, opts), { headers: this.buildHeaders(opts.headers, addDefaultHeaders) });
        if (this.authStrategy === 'OpString') {
            return Object.assign(Object.assign({}, resultOptions), {
                params: this.addServletParams(opts.params),
            });
        }
        return resultOptions;
    }
    /**
     * This a private function used to add default authentication parameters when servlets are called.
     */
    addServletParams(requestParams) {
        const opString = this.sm.getOpString();
        return Object.assign({ opString, authToken: opString }, requestParams);
    }
    /** Method to make GET http requests to servers.
     * @param url URL for http request
     * @param options These are http options for request. Should be used to add headers, params
     * @returns an `Observable` of the body as any
    */
    get(url, options) {
        return this.http.get(url, this.buildHttpOptions(options)).pipe(catchError(this.handleError('get')));
    }
    /** Method to make POST http requests to servers.
     * @param url URL for http request
     * @param data json body for post call
     * @param options These are http options for request. Should be used to add headers, params
     * @returns an `Observable` of the body as any
    */
    post(url, data, options) {
        return this.http.post(url, JSON.stringify(data), this.buildHttpOptions(options)).pipe(catchError(this.handleError('add')));
    }
    /** Method to make PUT http requests to servers.
     * @param url URL for http request
     * @param data json body for PUT call
     * @param options These are http options for request. Should be used to add headers, params
     * @returns an `Observable` of the body as any
    */
    update(url, data, options) {
        return this.http.put(url, JSON.stringify(data), this.buildHttpOptions(options)).pipe(catchError(this.handleError('update')));
    }
    /** Method to make DELETE http requests to servers.
       * @param url URL for http request
       * @param options These are http options for request. Should be used to add headers, params
       * @returns an `Observable` of the body as any
      */
    delete(url, options) {
        return this.http.delete(url, this.buildHttpOptions(options)).pipe(catchError(this.handleError('delete')));
    }
    /** Method to make PATCH http requests to servers.
       * @param url URL for http request
       * @param data json body for patch call
       * @param options These are http options for request. Should be used to add headers, params
       * @returns an `Observable` of the body as any
      */
    patch(url, data, options) {
        return this.http.patch(url, JSON.stringify(data), this.buildHttpOptions(options)).pipe(catchError(this.handleError('patch')));
    }
}
RestService.ɵfac = function RestService_Factory(t) { return new (t || RestService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(SessionManagerService), ɵngcc0.ɵɵinject(AUTH_STRATEGY, 8)); };
RestService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: RestService, factory: RestService.ɵfac });
RestService.ctorParameters = () => [
    { type: HttpClient },
    { type: SessionManagerService },
    { type: String, decorators: [{ type: Optional }, { type: Inject, args: [AUTH_STRATEGY,] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(RestService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: SessionManagerService }, { type: String, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [AUTH_STRATEGY]
            }] }]; }, null); })();

const opStringStrategyProvider = {
    provide: AUTH_STRATEGY,
    useValue: 'OpString',
};
class ServletService extends RestService {
    constructor(http, sm) {
        super(http, sm, opStringStrategyProvider.useValue);
    }
}
ServletService.ɵfac = function ServletService_Factory(t) { return new (t || ServletService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(SessionManagerService)); };
ServletService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: ServletService, factory: ServletService.ɵfac });
ServletService.ctorParameters = () => [
    { type: HttpClient },
    { type: SessionManagerService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ServletService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: SessionManagerService }]; }, null); })();

class AuthenticateService {
    constructor(http, commonUtils, acl, servlet, sm) {
        this.http = http;
        this.commonUtils = commonUtils;
        this.acl = acl;
        this.servlet = servlet;
        this.sm = sm;
    }
    /**
     * Clear sessions and delete the api token from backend.
     * Redirects to appropriate application login screen
     */
    logout() {
        const appName = this.sm.getAppName();
        const loginUrl = AppLoginUrl[appName];
        if (this.sm.isSSOEnabled()) {
            this.logoutApp(appName).subscribe((data) => {
                this.clearSessionAndRedirect(data.success ? data.success.logoutUrl : loginUrl);
            }, () => this.clearSessionAndRedirect(loginUrl));
        }
        else {
            this.legacyLogout(appName).subscribe(() => this.clearSessionAndRedirect(loginUrl), () => this.clearSessionAndRedirect(loginUrl));
        }
    }
    logoutApp(appName) {
        const params = {
            operId: '2',
            app: appName
        };
        return this.servlet.post("/AdGainMgmt/Authenticate" /* authenticate */, null, { params });
    }
    /**
     * Clear the session and redirect to given url
     * @param url To redirect to given location
     */
    clearSessionAndRedirect(url) {
        this.sm.clearCookiesAndSession();
        this.commonUtils.redirectTo(url);
    }
    legacyLogout(appName) {
        if (appName === "PUBLISHER_ADMIN" /* PUBLISHER_ADMIN */) {
            return this.adminLogout().pipe(mergeMap(() => this.deleteToken()));
        }
        else {
            return this.deleteToken();
        }
    }
    adminLogout() {
        const params = {
            operId: '1',
            opString: this.acl.token.value
        };
        return this.servlet.get("/AdGainMgmt/Login" /* login */, { params });
    }
    deleteToken() {
        const headers = new HttpHeaders().set(this.acl.token.key, this.acl.token.value);
        return this.http.delete("/api/castrum/token" /* token */, { headers });
    }
}
AuthenticateService.ɵfac = function AuthenticateService_Factory(t) { return new (t || AuthenticateService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(CommonUtilsService), ɵngcc0.ɵɵinject(AclService), ɵngcc0.ɵɵinject(ServletService), ɵngcc0.ɵɵinject(SessionManagerService)); };
AuthenticateService.ɵprov = i0.ɵɵdefineInjectable({ factory: function AuthenticateService_Factory() { return new AuthenticateService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(CommonUtilsService), i0.ɵɵinject(AclService), i0.ɵɵinject(ServletService), i0.ɵɵinject(SessionManagerService)); }, token: AuthenticateService, providedIn: "root" });
AuthenticateService.ctorParameters = () => [
    { type: HttpClient },
    { type: CommonUtilsService },
    { type: AclService },
    { type: ServletService },
    { type: SessionManagerService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AuthenticateService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: CommonUtilsService }, { type: AclService }, { type: ServletService }, { type: SessionManagerService }]; }, null); })();

const NOT_AUTHORIZED = 401;
class AuthInterceptor {
    constructor(authenticate) {
        this.authenticate = authenticate;
    }
    intercept(request, next) {
        return next.handle(request).pipe(catchError((error) => {
            if (error.status === NOT_AUTHORIZED) {
                this.authenticate.logout();
            }
            return throwError(error);
        }));
    }
}
AuthInterceptor.ɵfac = function AuthInterceptor_Factory(t) { return new (t || AuthInterceptor)(ɵngcc0.ɵɵinject(AuthenticateService)); };
AuthInterceptor.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: AuthInterceptor, factory: AuthInterceptor.ɵfac });
AuthInterceptor.ctorParameters = () => [
    { type: AuthenticateService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AuthInterceptor, [{
        type: Injectable
    }], function () { return [{ type: AuthenticateService }]; }, null); })();

var GA_DIMENSION;
(function (GA_DIMENSION) {
    GA_DIMENSION["USER_TYPE"] = "1";
    GA_DIMENSION["USER_NAME"] = "2";
    GA_DIMENSION["ACCOUNT_TYPE"] = "3";
    GA_DIMENSION["ACCOUNT_NAME"] = "4";
    GA_DIMENSION["ACCOUNT_ID"] = "5";
})(GA_DIMENSION || (GA_DIMENSION = {}));
var GA_USER_TYPE;
(function (GA_USER_TYPE) {
    GA_USER_TYPE["INTERNAL"] = "Internal";
    GA_USER_TYPE["EXTERNAL"] = "External";
})(GA_USER_TYPE || (GA_USER_TYPE = {}));
class GoogleAnalyticsService {
    constructor(router, sm) {
        this.router = router;
        this.sm = sm;
        this.defaultConfig = {
            clearIds: true,
            clearQueryParams: true,
            idsRegExp: /\/\d(-|\d)*/g,
            usePathname: true,
            clearHash: true,
            trackDimensions: true
        };
    }
    ga(...args) {
        if (!window.ga) {
            console.warn('Could not find GA script');
        }
        else {
            window.ga(...args);
        }
    }
    /**
     * @param userConfig?:{GaConfig}
     */
    startTracking(userConfig) {
        this.activeConfig = Object.assign(Object.assign({}, this.defaultConfig), userConfig);
        this.setRouteListener();
        this.startSessionTracking();
    }
    setRouteListener() {
        this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                const currentPath = this.getFormattedUrl(event.urlAfterRedirects);
                this.trackRouteChange(currentPath);
            }
        });
    }
    getFormattedUrl(urlAfterRedirects) {
        let url = this.activeConfig.usePathname
            ? window.location.pathname
            : urlAfterRedirects;
        url = this.activeConfig.clearHash ? url.replace('#/', '') : url;
        url = this.activeConfig.clearIds
            ? url.replace(this.activeConfig.idsRegExp, '')
            : url;
        url = this.activeConfig.clearQueryParams ? url.split('?')[0] : url;
        return url;
    }
    trackRouteChange(currentPath) {
        this.sendPageView(currentPath);
    }
    startSessionTracking() {
        if (this.sm.isInitialized() &&
            this.activeConfig.trackDimensions) {
            this.setUserType();
            this.setUserName();
            this.setAccountType();
            this.setAccountName();
            this.setAccountId();
        }
    }
    setUserType() {
        const isInternalUser = this.sm.get('userIsAdmin'), userType = isInternalUser
            ? GA_USER_TYPE.INTERNAL
            : GA_USER_TYPE.EXTERNAL;
        this.setCustomDimension(GA_DIMENSION.USER_TYPE, userType);
    }
    setUserName() {
        const user = this.sm.getUser() || { firstName: '', lastName: '' }, firstName = user.firstName, lastName = user.lastName, gaDimVal = firstName + ' ' + lastName;
        this.setCustomDimension(GA_DIMENSION.USER_NAME, gaDimVal);
    }
    setAccountType() {
        const GA_ACCOUNT_TYPE = { 1: 'Publisher', 5: 'Demand', 7: 'Demand' };
        this.setCustomDimension(GA_DIMENSION.ACCOUNT_TYPE, GA_ACCOUNT_TYPE[this.sm.getAccountType()]);
    }
    setAccountName() {
        const accountDetails = this.sm.getAccountDetails() || {};
        const gaDimVal = accountDetails.companyName || '';
        this.setCustomDimension(GA_DIMENSION.ACCOUNT_NAME, gaDimVal);
    }
    setAccountId() {
        const gaDimVal = this.sm.getAccountId() || 'NA';
        this.setCustomDimension(GA_DIMENSION.ACCOUNT_ID, gaDimVal);
    }
    set(...args) {
        this.ga('set', ...args);
    }
    setPage(pageName) {
        this.set('page', pageName);
    }
    setCustomDimension(index, value) {
        this.set('dimension' + index, value);
    }
    setCustomMetric(index, value) {
        this.set('metric' + index, value);
    }
    send(hitType, ...args) {
        this.ga('send', hitType, ...args);
    }
    sendEvent(...args) {
        this.send('event', ...args);
    }
    sendPageView(...args) {
        this.send('pageview', ...args);
    }
}
GoogleAnalyticsService.ɵfac = function GoogleAnalyticsService_Factory(t) { return new (t || GoogleAnalyticsService)(ɵngcc0.ɵɵinject(ɵngcc2.Router), ɵngcc0.ɵɵinject(SessionManagerService)); };
GoogleAnalyticsService.ɵprov = i0.ɵɵdefineInjectable({ factory: function GoogleAnalyticsService_Factory() { return new GoogleAnalyticsService(i0.ɵɵinject(i1$1.Router), i0.ɵɵinject(SessionManagerService)); }, token: GoogleAnalyticsService, providedIn: "root" });
GoogleAnalyticsService.ctorParameters = () => [
    { type: Router },
    { type: SessionManagerService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(GoogleAnalyticsService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc2.Router }, { type: SessionManagerService }]; }, null); })();

class FileService extends RestService {
    constructor(http, sm, authStrategy) {
        super(http, sm, authStrategy);
    }
    download(url, options, fileName) {
        return this.http.get(url, Object.assign(Object.assign({}, this.buildHttpOptions(options)), { observe: 'response', responseType: 'blob' })).pipe(map((response) => {
            const fileType = this.getFileType(response.headers);
            const file = new Blob([response.body], { type: fileType });
            return this.delegateToDownload(file, fileName || this.getFileName(response.headers));
        }), catchError(this.handleError('download')));
    }
    downloadOnUrl(url, filename = 'file.csv', params, addServletParams = false) {
        const path = addServletParams
            ? this.getPath(url, this.addServletParams(params))
            : this.getPath(url, params);
        this.downloadByUrl(path, filename);
    }
    upload(url, file, options, fileName = 'file') {
        return this._uploadWithMethod('post', url, file, fileName, options);
    }
    put(url, file, options, fileName = 'file') {
        return this._uploadWithMethod('put', url, file, fileName, options);
    }
    getPath(url, params) {
        return url + '?' + new HttpParams({ fromObject: params }).toString();
    }
    getFileName(headers) {
        const contentDispositionHeader = headers.get('Content-Disposition') || ';filename=file.csv';
        const result = contentDispositionHeader.split(';')[1].trim().split('=')[1];
        return result.replace(/"/g, '');
    }
    getFileType(headers) {
        return headers.get('Content-Type');
    }
    delegateToDownload(blob, fileName) {
        const url = window.URL.createObjectURL(blob);
        const link = this.downloadByUrl(url, fileName);
        window.URL.revokeObjectURL(url);
        return link;
    }
    downloadByUrl(url, fileName) {
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName;
        link.dispatchEvent(new MouseEvent('click', {
            bubbles: true,
            cancelable: true,
            view: window
        }));
        return link;
    }
    _uploadWithMethod(method, url, file, fileName, options) {
        const body = RestService.createFormData(options && options.bodyParams ? options.bodyParams : {});
        body.append(fileName, file, file.name);
        return this.http[method](url, body, this.buildHttpOptions(options, false))
            .pipe(catchError(this.handleError('upload')));
    }
}
FileService.ɵfac = function FileService_Factory(t) { return new (t || FileService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(SessionManagerService), ɵngcc0.ɵɵinject(AUTH_STRATEGY, 8)); };
FileService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: FileService, factory: FileService.ɵfac });
FileService.ctorParameters = () => [
    { type: HttpClient },
    { type: SessionManagerService },
    { type: String, decorators: [{ type: Optional }, { type: Inject, args: [AUTH_STRATEGY,] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FileService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: SessionManagerService }, { type: String, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [AUTH_STRATEGY]
            }] }]; }, null); })();

class NavigatorService {
    constructor(commonUtils) {
        this.commonUtils = commonUtils;
    }
    /**
     * @param target target is the url it will be redirected to.
     * Target is optional.
     * If not provided it will redirect to the home page of that app.
     */
    toInject(target) {
        const url = target
            ? `${"/v2/navigator/inject" /* INJECT */}?target=${encodeURIComponent(target)}`
            : "/v2/navigator/inject" /* INJECT */;
        this.commonUtils.redirectTo(url);
    }
    /**
     * Navigate to the page with `id = pageId`.
     * @param pageId id of the page
     */
    toPage(pageId) {
        const url = "/v2/navigator/to/page" /* TO_PAGE */ + '/' + pageId;
        this.commonUtils.redirectTo(url);
    }
    /**
     * Navigate to the login page of `appName`.
     * @param appName appName is optional. if provided this will work like `redirectToLogin` from SM (passing the ref by default).
     * If not provided it will determine the `appName` based on the current url.
     */
    toLogin(appName) {
        let url = "/v2/navigator/to/login" /* TO_LOGIN */;
        switch (appName) {
            case "PUBLISHER" /* PUBLISHER */:
                url = url + '/' + "publisher" /* PUBLISHER */;
                break;
            case "PUBLISHER_ADMIN" /* PUBLISHER_ADMIN */:
                url = url + '/' + "admin" /* PUBLISHER_ADMIN */;
                break;
            case "DEMAND" /* DEMAND */:
                url = url + '/' + "demand" /* DEMAND */;
                break;
            case "DEMAND_ADMIN" /* DEMAND_ADMIN */:
                url = url + '/' + "demand_admin" /* DEMAND_ADMIN */;
                break;
            case "COMMUNITY" /* COMMUNITY */:
                url = url + '/' + "community" /* COMMUNITY */;
                break;
        }
        url = url + `?ref=${encodeURIComponent(location.pathname)}`;
        this.commonUtils.redirectTo(url);
    }
    /**
     * Navigate to the home page of current app.
     */
    toHome() {
        this.commonUtils.redirectTo("/v2/navigator/to/home" /* TO_HOME */);
    }
}
NavigatorService.ɵfac = function NavigatorService_Factory(t) { return new (t || NavigatorService)(ɵngcc0.ɵɵinject(CommonUtilsService)); };
NavigatorService.ɵprov = i0.ɵɵdefineInjectable({ factory: function NavigatorService_Factory() { return new NavigatorService(i0.ɵɵinject(CommonUtilsService)); }, token: NavigatorService, providedIn: "root" });
NavigatorService.ctorParameters = () => [
    { type: CommonUtilsService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NavigatorService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: CommonUtilsService }]; }, null); })();

const DEFAULT_PENDO_SCRIPT_ORIGIN = 'https://cdn.pendo.io';
const PENDO_SETTINGS_TOKEN = new InjectionToken('pendo-settings', {
    factory: () => ({ pendoEnabled: false, pendoApiKey: '' }),
});
const PENDO_INITIALIZER_PROVIDER = {
    provide: APP_INITIALIZER,
    multi: true,
    useFactory: pendoInitializer,
    deps: [
        PENDO_SETTINGS_TOKEN,
    ],
};
let pendoScript;
function pendoInitializer($settings) {
    return () => __awaiter(this, void 0, void 0, function* () {
        if ($settings.pendoEnabled) {
            yield new Promise((resolve, reject) => {
                pendoScript = document.createElement('script');
                pendoScript.async = true;
                pendoScript.src = `${DEFAULT_PENDO_SCRIPT_ORIGIN}/agent/static/${$settings.pendoApiKey}/pendo.js`;
                document.head.appendChild(pendoScript);
                pendoScript.onerror = () => __awaiter(this, void 0, void 0, function* () {
                    // The script may have been blocked by an ad blocker
                    resolve();
                });
                pendoScript.onload = () => __awaiter(this, void 0, void 0, function* () {
                    // when enableDebugging should load extra js
                    const sub = interval(100).subscribe(() => {
                        if (window['pendo']) {
                            sub.unsubscribe();
                            resolve();
                        }
                    });
                });
            });
        }
    });
}

// TODO: remove this additional declaration and use ResourceType directly
var AccountType;
(function (AccountType) {
    AccountType[AccountType["PUBLISHER"] = 1] = "PUBLISHER";
    AccountType[AccountType["SITE"] = 2] = "SITE";
    AccountType[AccountType["AD_TAG"] = 3] = "AD_TAG";
    AccountType[AccountType["AD_NETWORK"] = 4] = "AD_NETWORK";
    AccountType[AccountType["DEMAND_PARTNER"] = 5] = "DEMAND_PARTNER";
    AccountType[AccountType["CAMPAIGN"] = 6] = "CAMPAIGN";
    AccountType[AccountType["ATD"] = 7] = "ATD";
    AccountType[AccountType["DATA_PROVIDER"] = 8] = "DATA_PROVIDER";
    AccountType[AccountType["RESELLER"] = 9] = "RESELLER";
})(AccountType || (AccountType = {}));
var DemandAccountType;
(function (DemandAccountType) {
    DemandAccountType["DATA_PROVIDER"] = "DATA_PROVIDER";
    DemandAccountType["BUYER"] = "ATD";
    DemandAccountType["PARENT_BUYER"] = "PARENT_BUYER";
})(DemandAccountType || (DemandAccountType = {}));

class PendoService {
    constructor(sm, commonUtilsService) {
        this.sm = sm;
        this.commonUtilsService = commonUtilsService;
    }
    getPendoObject() {
        const env = this.commonUtilsService.getEnvironmentName();
        const currentApp = this.sm.get('currentApp');
        const userIsAdmin = this.sm.get('userIsAdmin');
        const user = this.sm.getUser();
        if (currentApp && this.validateUserInfo(user)) {
            const isProdEnvironment = this.commonUtilsService.isProdEnvironment();
            const userId = String(user.id);
            const visitor = {
                id: isProdEnvironment ? userId : `test_${env}_${userId}`,
                salesforceUserId: userId,
                email: user.email,
                // TODO: deprecate fullName in next major version
                fullName: user.firstName + ' ' + user.lastName,
                full_name: user.firstName + ' ' + user.lastName,
                userName: user.username,
                role: currentApp,
                isInternalUser: userIsAdmin,
            };
            if (currentApp !== "admin" /* PUBLISHER_ADMIN */ && currentApp !== "demand_admin" /* DEMAND_ADMIN */) {
                const accountDetails = this.sm.getAccountDetails();
                // TODO: remove AccountType and use ResourceType directly
                const accountType = AccountType[this.sm.getAccountType()];
                if (this.validateAccountDetails(accountDetails) && accountType) {
                    const accountId = String(accountDetails.id);
                    const account = {
                        id: isProdEnvironment ? accountId : `test_${env}_${accountId}`,
                        salesforceAccountId: accountId,
                        companyName: accountDetails.companyName,
                        accountType: accountType === DemandAccountType.BUYER ? this._getATDAccountType() : accountType,
                        isInternalUser: userIsAdmin,
                    };
                    return { visitor, account };
                }
                else {
                    console.error("Account metadata not found" /* ACCOUNT_METADATA_NOT_FOUND */);
                    return null;
                }
            }
            return { visitor };
        }
        console.error("Visitor metadata not found" /* VISITOR_METADATA_NOT_FOUND */);
        return null;
    }
    validateAccountDetails(accountDetails) {
        return accountDetails.hasOwnProperty('id') && accountDetails.hasOwnProperty('companyName');
    }
    validateUserInfo(user) {
        const userProperties = [
            'id', 'firstName', 'lastName', 'email', 'username',
        ];
        return userProperties.every((property) => user.hasOwnProperty(property));
    }
    /**
     * Check if pendo script is actually loaded or not before calling the initialise method
     */
    get isPendoDefined() {
        return typeof pendo !== 'undefined';
    }
    /**
     * Use this function to initialize pendo in ui-micro-app
     */
    initialize() {
        const pendoObject = this.getPendoObject();
        if (this.isPendoDefined && pendoObject) {
            pendo.initialize(pendoObject);
        }
        else {
            console.error("Something went wrong! pendo is not initialised" /* PENDO_IS_NOT_INITIALISED */);
        }
    }
    track(eventName, metadata) {
        if (this.isPendoDefined && pendo.isReady()) {
            pendo.track(eventName, metadata);
        }
        else {
            console.error("pendo.track() called before pendo is initialised" /* PENDO_TRACK_CALLED_BEFORE_INITIALISED */);
        }
    }
    _getATDAccountType() {
        if (this._resourceCanRead(235 /* BLOCK_ANALYTICS_FOR_BUYER */)) {
            return DemandAccountType.PARENT_BUYER;
        }
        else if (this._resourceCanRead(219 /* DATA_PROVIDER */)) {
            return DemandAccountType.DATA_PROVIDER;
        }
        else {
            return DemandAccountType.BUYER;
        }
    }
    _resourceCanRead(featureId) {
        return this.sm.getAccountAccess(featureId) >= 1 /* READ */;
    }
}
PendoService.ɵfac = function PendoService_Factory(t) { return new (t || PendoService)(ɵngcc0.ɵɵinject(SessionManagerService), ɵngcc0.ɵɵinject(CommonUtilsService)); };
PendoService.ɵprov = i0.ɵɵdefineInjectable({ factory: function PendoService_Factory() { return new PendoService(i0.ɵɵinject(SessionManagerService), i0.ɵɵinject(CommonUtilsService)); }, token: PendoService, providedIn: "root" });
PendoService.ctorParameters = () => [
    { type: SessionManagerService },
    { type: CommonUtilsService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PendoService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: SessionManagerService }, { type: CommonUtilsService }]; }, null); })();

class PendoModule {
    static forRoot(settings) {
        return {
            ngModule: PendoModule,
            providers: [
                {
                    provide: PENDO_SETTINGS_TOKEN,
                    useValue: settings
                },
                PENDO_INITIALIZER_PROVIDER,
                PendoService,
            ],
        };
    }
    static forChild() {
        return {
            ngModule: PendoModule,
            providers: [
                PendoService,
            ],
        };
    }
}
PendoModule.ɵfac = function PendoModule_Factory(t) { return new (t || PendoModule)(); };
PendoModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: PendoModule });
PendoModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PendoModule, [{
        type: NgModule,
        args: [{
                declarations: [],
                imports: [],
                exports: []
            }]
    }], null, null); })();

class UiCoreModule {
}
UiCoreModule.ɵfac = function UiCoreModule_Factory(t) { return new (t || UiCoreModule)(); };
UiCoreModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: UiCoreModule });
UiCoreModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [
        SessionManagerService,
        AclService,
        ServletService,
        AuthenticateService,
        CommonUtilsService,
        GoogleAnalyticsService,
        RestService,
        FileService,
        NavigatorService,
        { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true }
    ], imports: [[
            HttpClientModule,
            PendoModule,
        ], PendoModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(UiCoreModule, [{
        type: NgModule,
        args: [{
                declarations: [],
                imports: [
                    HttpClientModule,
                    PendoModule,
                ],
                exports: [
                    PendoModule,
                ],
                providers: [
                    SessionManagerService,
                    AclService,
                    ServletService,
                    AuthenticateService,
                    CommonUtilsService,
                    GoogleAnalyticsService,
                    RestService,
                    FileService,
                    NavigatorService,
                    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true }
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(UiCoreModule, { imports: function () { return [HttpClientModule, PendoModule]; }, exports: function () { return [PendoModule]; } }); })();

/*
 * Reactive loader guarantees of no load collisions and loading status provided.
 * Usage example: you load list <T2> type by requesting type <T1> from rest service
 * if you pass changes to this component by changing Id it will guarantee render the domainList of last request
 * If you just call domainService.list(this.id) it will show response which comes faster.
 * Another example is pagination. If you click fast and loading duration differs some pages may be shown in wrong
 * sequence, but loader will cut old requests off, replacing them by new one.
 *
 * <div *ngIf=loader.loaded">
 *   <ul>
 *     <li *ngFor="let domain of domains"
 *         [textContent]="domain.name">
 *     </li>
 *   </ul>
 * </div>
 *
 * class DomainListComponent implements OnChanges {
 *   @Input() domainId: DomainId;
 *   loader: ReactiveLoader<DomainList, DomainId>
 *
 *   constructor(private domainService:DomainService) {
 *     this.loader = new ReactiveLoader(id => this.domainService.list(id));
 *     this.loader.subscribe(list => {
 *       this.listToRender = list;
 *     });
 *   }
 *
 *   ngOnChanges() {
 *     this.loader.load(album.id);
 *   }
 * }
 */
class ReactiveLoader {
    constructor(loaderFunction, initiallyLoaded = false) {
        this._loaded = false;
        this._loaded = initiallyLoaded;
        this._requestQueue = new Subject();
        this._errorQueue = new Subject();
        this._resultQueue = this._requestQueue.pipe(switchMap(_ => {
            this._loaded = false;
            return loaderFunction(_)
                .pipe(catchError(err => {
                this._loaded = true;
                this._errorQueue.next(err);
                return EMPTY;
            }));
        }), map(_ => {
            this._loaded = true;
            return _;
        }));
    }
    load(arg) {
        this._requestQueue.next(arg);
    }
    subscribe(successFn, errorFn, completeFn) {
        this._errorQueue.subscribe(err => {
            errorFn(err);
        });
        return this._resultQueue.subscribe(successFn, errorFn, completeFn);
    }
    complete() {
        this._requestQueue.complete();
        this._errorQueue.complete();
    }
    get loaded() {
        return this._loaded;
    }
    get value() {
        return this._resultQueue;
    }
}

/**
 * Transforms response errors from various APIs into a single format
 * (see ApiError).
 * Usage:
 * ```
 *   this.service
 *     .method()
 *     .subscribe(
 *       () => { / ... / },
 *       (err) => {
 *         const errors = coerceResponseErrors(err); // <---
 *       }
 *     )
 * ```
 */
function coerceResponseErrors(response) {
    if (isErrorResponse(response)) {
        return fromErrorResponse(response);
    }
    return coerceArray(response).map(fromErrorOrString);
}
function fromErrorResponse({ error }) {
    if (Array.isArray(error)) {
        return error.map(fromErrorLike);
    }
    if (Array.isArray(error.errorList)) {
        return error.errorList.map(fromErrorLike);
    }
    return [{ message: error }];
}
function fromErrorLike(err) {
    return {
        code: err.errorCode,
        message: err.errorMessage || err.message || err.error
    };
}
function fromErrorOrString(e) {
    return {
        message: e instanceof Error ? e.message : e
    };
}
function isErrorResponse(response) {
    return (response !== null && typeof response === 'object' && 'error' in response);
}

/*
 * Public API Surface of ui-core
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AUTH_STRATEGY, AclService, AppLoginUrl, AuthInterceptor, AuthenticateService, CommonUtilsService, FileService, GA_DIMENSION, GA_USER_TYPE, GoogleAnalyticsService, NavigatorService, PENDO_INITIALIZER_PROVIDER, PENDO_SETTINGS_TOKEN, PendoModule, PendoService, ReactiveLoader, RestService, ServletService, SessionManagerService, UiCoreModule, coerceResponseErrors, opStringStrategyProvider, pendoInitializer, pendoScript, pubtokenStrategyProvider, WINDOW as ɵa, ApiBase as ɵb };

